import React from 'react'
import "@fontsource/poppins"; // Defaults to weight 400
import Logo from '../assets/img/onboarding/logo.png'
import ProgressBar from 'react-bootstrap/ProgressBar';

import SiteBuilder, {
  BUTTON_STYLES,
  FEATURE_PRODUCT_STYLE,
  BRAND_STYLE,
  LOGO_POSITIONS,
  CHECKOUT_STYLE,
  BANNER_STYLES,
  BLOCKS,
  ADD_ONS
} from '../utils/SiteBuilder'

import Notify from "../utils/Notify";
import ColorPicker from "./ColorPicker";
import Separator from "../components/common/Separator";
import Backend from "../utils/Backend";
import Website from "../utils/Website";
import moment from "moment";
import AuthManager from "../utils/AuthManager";
import ImagePickerModal from "../components/modal/ImagePickerModal";
import General from "../utils/General";
import {RotatingLines} from "react-loader-spinner";
import $ from 'jquery';

const MIN_LOADING_TIME = 8000

export default class Onboarding extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      currentUser: AuthManager.getCurrentUser(),
      website: props.website,
      color: props.website.primary_color,
      email: '',
      password: '',
      isLoading: false,
      blocks: [],
      similarImages: [],
      bannerStyle: '',
      featureProductStyle: '',
      checkoutStyle: '',
      brandStyle: '',
      buttonStyle: '',
      logoPosition: '',
      companyDescription: '',
    }

  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState(nextProps)
  }

  componentDidMount(){
    Backend.getCCPages();
  }

  _onDashboardClicked() {
    General.openEditFunnel();
  }

  _getCompanyDescription = General.debounce(() => {
    let {
      website,
      tagLine
    } = this.state

    if(!tagLine){
      return
    }

    return Backend.generateText(`${website.name} - ${tagLine}`)
      .then(response => {
        this.setState({
          company_about_us: response.body,
          company_our_mission: response.mission,
          company_services: {
            services: response.services,
            highlight: response.highlight,
          },
        })
      })
      .catch(error => {
        console.log("****", error)
      })
  }, 500)

  _isSignUpFormValid(){
    let {
      image,
      color,
      tagLine,
      checkoutStyle,
      buttonStyle,
      logoPosition,
      bannerStyle,
      featureProductStyle,
      companyDescription
    } = this.state

    let error = null
    let fieldId = null


    if(!color){
      error = "Please select a brand color"
      fieldId = "primary_color"
    }
    else if(!buttonStyle){
      error = "Please select a button style"
      fieldId = "button_style"
    }
    else if(!logoPosition){
      error = "Please select a logo position"
      fieldId = "logo_position"
    }
    else if(!bannerStyle){
      error = "Please select a main banner style"
      fieldId = "banner_style"
    }
    else if(!image){
      error = "Please select an image"
      fieldId = "banner_image"
    }
    else if(!featureProductStyle){
      error = "Please select how you would like to feature your products"
      fieldId = "product_block"
    }
    else if(!checkoutStyle){
      error = "Please select how you would like your customers to checkout"
      fieldId = "checkout_type"
    }
    else if(!tagLine){
      error = "Please include your business tagline or slogan"
      fieldId = "tag_line"
    }
    else if(!companyDescription){
      error = "Please describe your business in a few sentences"
      fieldId = "description"
    }

    if(error){
      Notify.error(error)
      if(fieldId){
        const container = $("#"+fieldId)
        if(container){
          container[0].scrollIntoView({behavior: "smooth"})
        }
      }
      return false
    }

    return true
  }

  _signUpPressed(e){
    e.preventDefault()

    if(!this._isSignUpFormValid()){
      return
    }

    let startTime = moment()
    this.setState({ isLoading: true })

    let siteBuilder = new SiteBuilder(this.state)
    let data = siteBuilder.getBaseDetails()
    data.page.content_blocks = siteBuilder.getContentBlocks(this.state)

    Backend.createPage(data)
      .then(response => {
        General.setLocationHref(`/${response.website.slug}/${response.slug}`)
      })
      .catch(error => {
        this.setState({
          isLoading: false,
        })
        Notify.error(error.message)
      })
  }

  render(){

    let {
      image,
      imageLoading,
      blocks,
      color,
      bannerStyle,
      featureProductStyle,
      checkoutStyle,
      brandStyle,
      buttonStyle,
      logoPosition,
      isLoading,
      website,
      currentUser,
      showImagePicker
    } = this.state

    let siteBuilder = new SiteBuilder(this.state)
    const progress = siteBuilder.getProgress();

    let points = [
      "Create Pages Within Seconds",
      "Increase Your Conversion Rate",
      "Advanced Add-Ons & Tools"
    ];

    return (
      <>
        <div className="page onboarding">
          {/* begin : aside */}
          <div className="aside">
            <div className='as-main'>
              <img className='logo' src={Logo} alt='' />
              <h1>Hi, fill in the questionnaire to set up your store</h1>
              <div className='as-progress'>
                <ProgressBar
                  striped
                  animated
                  now={progress}
                  className="rct-progress"
                />
                <div className='txt'>{progress}% Completed</div>
              </div>
              <h3>Build Your Own eCommerce Store</h3>
              <ul>
                {points.map((point) => {
                  return (
                    <li>
                      <i class="flaticon2-check-mark"></i>
                      <span>{point}</span>
                    </li>
                  );
                })}
              </ul>

              <div className="text-left mb-5 pos-absolute pos-bottom">
                <a
                  href={"#"}
                  className="text-white"
                  style={{textDecoration: 'none'}}
                  title="Back to Funnel"
                  onClick={() => this._onDashboardClicked()}
                >
                  <i className="flaticon2-left-arrow"></i>
                  <span className="ml-2">Back to Funnel</span>
                </a>
              </div>

            </div>
          </div>
          {/* end : aside */}
          {/* begin : form create */}
          <div className={`create ${isLoading ? 'loading' : ''}`}>
            <div className='form'>
              <h2 className="m-b-50 text-muted">You can change all of these options later...</h2>
              {
                !website.primary_color &&
                <div id="primary_color" className="form-group required">
                  <label>
                    <span className='title'>Main Site Color</span>
                  </label>
                  <div className='field'>
                    <div className='choose'>
                      <ColorPicker
                        color={color}
                        onColorSelected={color => this.setState({color})}
                        COLORS={['#19E68A', '#3d85c6', '#e69138', '#fa6160', '#ffba00', '#674EA7', '#333333',]}
                      />
                    </div>
                  </div>
                </div>
              }

              {/* Starts : 02 - Button Style */}
              <div id="button_style" className="form-group required">
                <label>
                  <span className='title'>Button Style</span>
                </label>
                <div className='field'>
                  <div className='choose button-style'>
                    {BUTTON_STYLES.map((item) => (
                      <div
                        key={item.value}
                        className={`graphic btn ${item.css} ${buttonStyle === item.value ? ' selected flaticon2-check-mark' : ' '}`}
                        onClick={() =>
                          this.setState({buttonStyle: item.value})
                        }
                      >
                        <span>{item.text} Button</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* End */}

              {/* Starts : logo position Style */}
              <div id="logo_position" className="form-group required">
                <label>
                  <span className='title'>Logo Position</span>
                </label>
                <div className='field'>
                  <div className='choose logo-position'>
                    {LOGO_POSITIONS.map((item) => (
                      <div
                        key={item.value}
                        className={`graphic ${item.css} ${logoPosition === item.value ? ' selected flaticon2-check-mark' : ' '}`}
                        onClick={() =>
                          this.setState({logoPosition: item.value})
                        }
                      >
                        <div className='image'>{item.image}</div>
                        <div className='text'>{item.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* End : logo position Style */}

              {/* Starts : Main Banner Style */}
              <div id="banner_style" className="form-group required">
                <label>
                  <span className='title'>Main Banner Style</span>
                </label>
                <div className='field'>
                  <div className='choose main-banner'>
                    {BANNER_STYLES.map((item) => (
                      <div
                        key={item.value}
                        className={`graphic ${item.css} ${bannerStyle === item.value ? ' selected flaticon2-check-mark' : ' '}`}
                        onClick={() =>
                          this.setState({bannerStyle: item.value})
                        }
                      >
                        <div className='image'>{item.image}</div>
                        <div className='text'>{item.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Main Banner Style */}

              {/* Starts : 06 - Banner Image */}
              <div id="banner_image" className="form-group error required">
                <label>
                  <span className='title'>Banner Image</span>
                  <span className='sub-title'>Select an image for your banner background</span>
                </label>
                <div className='field'>
                  <div
                    className="choose choose-image d-flex justify-content-center align-items-center cursor-pointer"
                    onClick={() => this.setState({showImagePicker: true})}
                  >
                    {!image &&
                      <>
                        <div className="choose-image-overlay"/>
                        <div className="bg-text">
                          <p className="my-auto">Select A Suitable Image</p>
                        </div>
                      </>
                    }
                    {(image || imageLoading) &&
                      <div className="w-100 shimmer shimmer-overlay">
                        {image &&
                          <>
                            <div className="uploaded-image"
                                 style={{backgroundImage: "url(" + image.original + ")"}}></div>
                          </>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              {/* End */}

              {/* Starts : feature product style */}
              <div id="product_block" className="form-group required">
                <label>
                  <span className='title'>How do you want to feature any products?</span>
                </label>
                <div className='field'>
                  <div className='choose feature-product'>
                    {FEATURE_PRODUCT_STYLE.map((item) => (
                      <div
                        key={item.value}
                        className={`graphic ${item.css} ${featureProductStyle === item.value ? ' selected flaticon2-check-mark' : ' '}`}
                        onClick={() => {
                          let index = blocks.findIndex(o => o === item.value)
                          if (index === -1) {
                            blocks.push(item.value)
                          } else {
                            blocks.splice(index, 1)
                          }
                          this.setState({featureProductStyle: item.value, blocks})
                        }}
                      >
                        <div className='image'>{item.image}</div>
                        <div className='text'>{item.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* End : feature product style */}

              {/* Starts : checkout style */}
              <div id="checkout_type" className="form-group required">
                <label>
                  <span className='title'>What checkout experience would you prefer?</span>
                </label>
                <div className='field'>
                  <div className='choose checkout-style'>
                    {CHECKOUT_STYLE.map((item) => (
                      <div
                        key={item.value}
                        className={`graphic ${item.css} ${checkoutStyle === item.value ? ' selected flaticon2-check-mark' : ' '}`}
                        onClick={() =>
                          this.setState({checkoutStyle: item.value})
                        }
                      >
                        <div className='image'>{item.image}</div>
                        <div className='text'>{item.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* End : checkout style */}

              {/* Starts : brand style */}
              {/*<div class="form-group">*/}
              {/*  <label>*/}
              {/*    <span className='title'>How would you describe your brand?</span>*/}
              {/*  </label>*/}
              {/*  <div className='field'>*/}
              {/*    <div className='choose brand-style'>*/}
              {/*      {BRAND_STYLE.map((item) => (*/}
              {/*        <div*/}
              {/*          key={item.value}*/}
              {/*          className={`graphic ${item.css} ${brandStyle === item.value ? ' selected flaticon2-check-mark' : ' '}`}*/}
              {/*          onClick={() =>*/}
              {/*            this.setState({ brandStyle: item.value })*/}
              {/*          }*/}
              {/*        >*/}
              {/*          <div className='image'>{item.image}</div>*/}
              {/*          <div className='text'>{item.text}</div>*/}
              {/*        </div>*/}
              {/*      ))}*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/* End : brand style */}

              <Separator
                text="Blocks"
                css="color-charcoal v2"
              />

              <div className="form-group">
                <label>
                  <span className='title'>What blocks and panels would you like to add?</span>
                </label>
                <div className='field'>
                  <div className='choose-multiple-options'>
                    <div className="form-group option">
                      <div className='row'>
                        <label className="col col-md-9">
                          <span className='sub-title'>Reviews and Testimonials</span>
                        </label>
                        <div className="col-auto col-md-3">
                          <span className="kt-switch">
                            <label>
                              <input
                                type="checkbox"
                                name=""
                                onChange={(e) => {
                                  let index = blocks.findIndex(o => o === "testimonials")
                                  if (index === -1) {
                                    blocks.push("testimonials")
                                  } else {
                                    blocks.splice(index, 1)
                                  }
                                  this.setState({blocks})
                                }}
                              />
                              <span></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="form-group option">
                      <div className='row'>
                        <label className="col col-md-9">
                          <span className='sub-title'>Marketing</span>
                        </label>
                        <div className="col-auto col-md-3">
                          <span className="kt-switch">
                            <label>
                              <input
                                type="checkbox"
                                name=""
                                onChange={(e) => {
                                  let index = blocks.findIndex(o => o === "socials")
                                  if (index === -1) {
                                    blocks.push("socials")
                                  } else {
                                    blocks.splice(index, 1)
                                  }
                                  this.setState({blocks})
                                }}
                              />
                              <span></span>
                            </label>
                          </span>
                        </div>
                      </div>
                      {
                        blocks.findIndex(o => o === "socials") > -1 &&
                        <>
                          <div>
                            <label>
                              <span className='sub-title'>You can provide these links later</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                              placeholder="LinkedIn"
                              autoComplete="off"
                              onChange={e => this.setState({linkedIn: e.target.value})}
                            />
                            <input
                              type="text"
                              className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                              placeholder="Instagram"
                              autoComplete="off"
                              onChange={e => this.setState({instagram: e.target.value})}
                            />
                            <input
                              type="text"
                              className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                              placeholder="Facebook"
                              autoComplete="off"
                              onChange={e => this.setState({facebook: e.target.value})}
                            />
                            <input
                              type="text"
                              className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                              placeholder="Twitter"
                              autoComplete="off"
                              onChange={e => this.setState({twitter: e.target.value})}
                            />
                          </div>
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <Separator
                text="SEO"
                css="color-charcoal v2"
              />

              {/* Starts : Start tag line */}
              <div id="tag_line" className="form-group required">
                <div>
                  <label>
                    <span className='title'>Tagline or Slogan</span>
                  </label>
                </div>
                <input
                  type="text"
                  className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  placeholder="Tagline or slogan"
                  name="company_name"
                  autoComplete="off"
                  onChange={e => this.setState({tagLine: e.target.value})}
                  onBlur={() => this._getCompanyDescription()}
                />

              </div>
              {/* End : End tag line */}

              {/* Starts : Start description */}
              <div id="description" className="form-group required">
                <div>
                  <label>
                    <span className='title'>Please describe your business in a few sentences</span>
                  </label>
                </div>
                <input
                  type="text"
                  className="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  placeholder="Please describe your business in a few sentences"
                  name="company_name"
                  autoComplete="off"
                  onChange={e => this.setState({companyDescription: e.target.value})}
                />

              </div>
              {/* End : End description */}

              <button
                onClick={(e) => this._signUpPressed(e)}
                type="button"
                className="btn btn-primary"
                disabled={isLoading}
              >
                Create My Website
              </button>

            </div>
            {isLoading &&
              <div className='create-loading'>
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeWidth="5"
                  strokeColor='#e66819'
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            }
          </div>
          {/* end : form create */}
        </div>
        <ImagePickerModal
          show={showImagePicker}
          onImagesSelected={(image, similarImages) =>  {
            this.setState({ showImagePicker: false })
            Backend.addImage(image, false)
              .then(image => {
                this.setState({ image, similarImages })
              })
              .catch(error => {
                Notify.error(error.message)
              })
          }}
          onHide={() => this.setState({ showImagePicker: false })}
        />
      </>
    )
  }

}
